import { get } from '../../lib/actionHelpers.js';
import { store } from 'redux/lib/configureStore.js';
import { selectors } from 'selectors/selectors';
export const getNextechLeadPayments = (sync_id, platform_code, callback) => {
  const state = store.getState();
  return get(`/integrations/generic/payments/${platform_code}`, {
    query: {
      sync_id,
    },
    action: 'GET_NEXTECH_LEAD_PAYMENTS',
    callback,
  });
};
